module.exports = __webpack_public_path__ + "static/img/userbg3.4bc622f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userbg3.png
// module id = JY5g
// module chunks = 28